import { lerPerfil, trocarPerfil, type Perfil } from '../lib/perfil.js';
import { trocarModo } from '../lib/modo.js';
import { Alternador, Interruptor } from './ui/index.js';

const PERFIS = [
  {
    valor: 'avaliador',
    rotulo: 'Avaliador',
    titulo: 'Ver como avaliador da equipe Equiview',
  },
  { valor: 'haras', rotulo: 'Dono do haras', titulo: 'Ver como dono do haras' },
] as const satisfies readonly {
  valor: Perfil;
  rotulo: string;
  titulo: string;
}[];

/**
 * Faixa logo abaixo do topo, sempre a vista quando da para escolher como ver o
 * app: com dados ficticios ou sem login (previa, dev). Com login e dados reais,
 * o papel e o do login e a faixa nao aparece (ver Layout).
 */
/**
 * Com dados ficticios o proprio interruptor ja diz o que se ve; o aviso so
 * aparece quando importa: o que se cadastra sem login fica no aparelho.
 * Tambem usado no bloco de demonstracao da barra lateral.
 */
export function avisoDaFaixa(ficticia: boolean, previa: boolean): string | null {
  if (ficticia) return null;
  return previa
    ? 'Sem login: o que você cadastrar fica só neste aparelho.'
    : 'Login desligado para desenvolvimento (VITE_DEV_SEM_LOGIN).';
}

export function FaixaDeContexto({ ficticia, previa }: { ficticia: boolean; previa: boolean }) {
  const aviso = avisoDaFaixa(ficticia, previa);

  return (
    <div className="border-b border-borda bg-superficie">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-1 px-4 py-1.5 lg:px-8">
        <div className="flex items-center gap-2.5">
          <span className="hidden text-xs font-semibold tracking-wide text-apagado uppercase sm:inline">Ver como</span>
          <div className="flex min-h-9">
            <Alternador rotulo="Ver como" valor={lerPerfil()} onMudar={trocarPerfil} opcoes={PERFIS} />
          </div>
        </div>
        <Interruptor ligado={ficticia} onMudar={(ligado) => trocarModo(ligado ? 'demo' : 'real')}>
          Dados fictícios
        </Interruptor>
        {aviso && <p className="w-full pb-1 text-xs text-apagado md:ml-auto md:w-auto md:pb-0">{aviso}</p>}
      </div>
    </div>
  );
}
